export default __webpack_public_path__ + "static/international-metric-desktop-0a971f33e274a18b926adb718364cd5c.svg";